<template>
  <div id="app">
    <loadingOverlay :active="LoadingCounter > 0" />

    <div class="input-container">
      <b-input-group size="lg" prepend="Address">
        <b-form-input v-model="address" @change="addressChanged"></b-form-input>
      </b-input-group>
    </div>

    <div class="gmap-container">


      <GmapMap map-type-id="terrain" style="width: 100%; height: 100%" :center="{ lat: centerLat, lng: centerLon }"
        :zoom="Zoom">
        <GmapMarker :key="index" v-for="(park, index) in  parks " :icon="{
          url: 'map_icon_small.png'
        }" :title="park.name" :clickable="true" :position="{
  lat: park.lat,
  lng: park.lon,
}">

          <GmapInfoWindow>
            <div>{{ park.name }}</div>
          </GmapInfoWindow>

        </GmapMarker>
      </GmapMap>
    </div>

  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import * as VueGoogleMaps from "vue2-google-maps";
import { GetMapAPIKey, GetParksCloseToAddressURL, GetParksCloseToLocationURL } from "../../shared/Shared";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Axios from 'axios';
import SimplePark from "../../shared/SimplePark";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';


Vue.use(Loading);
Vue.component("loadingOverlay", Loading);

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(VueGoogleMaps, {
  load: {
    key: GetMapAPIKey(),
    libraries: "places,drawing,visualization", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

class MapData {
  centerLat = 0;
  centerLon = 0;
  address = "";
  parks: SimplePark[] = [];
  LoadingCounter = 0;
  Zoom = 3;
  infoWinOpen = false;
}

export default Vue.extend({
  name: 'App',
  data() {
    return new MapData();
  },

  created() {


    if ("geolocation" in navigator) {
      // Prompt user for permission to access their location
      navigator.geolocation.getCurrentPosition((location) => {

        debugger;

        this.LoadingCounter++;
        Axios.get<SimplePark[]>(GetParksCloseToLocationURL(location.coords.latitude, location.coords.longitude))
          .then((result) => this.setParkLocation(result.data, "")).finally(() => {
            this.LoadingCounter--;
          });

      });
    }


  },

  methods: {

    setParkLocation(parks: SimplePark[], address = "") {

      this.parks = parks;

      let avgLat = 0;
      let avgLon = 0;

      if (parks.length) {
        for (const park of parks) {
          avgLat += park.lat;
          avgLon += park.lon;
        }
        this.centerLat = avgLat / parks.length;
        this.centerLon = avgLon / parks.length;
        this.Zoom = 10;
      }
      else {
        if (address) {
          alert("Could not find any parks within 100km of " + address);
        }
        else {
          alert("Could not find any parks within 100km of your current location");
        }
      }

    },

    addressChanged(address: string) {

      this.LoadingCounter++;
      Axios.get<SimplePark[]>(GetParksCloseToAddressURL(address))
        .then((result) => this.setParkLocation(result.data, address)).finally(() => {
          this.LoadingCounter--;
        });
    }
  }
});
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.fullscreen {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}

body,
html,
#app {
  .fullscreen
}

.input-container {
  margin: 10px;
}

.gmap-container {
  position: absolute;
  top: 68px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}

button.gm-ui-hover-effect {
  display: none !important;
}
</style>
